<template>
  <div>
    <div id="mylist" style="top: 0px">
      <div id="photo">
        <img :src="bg[nowBg]" class="bg" />
        <Tabs>
          <TabPane label="车辆状态">
            <car-status></car-status>
          </TabPane>
          <TabPane label="里程排行">
            <licheng></licheng>
          </TabPane>
          <TabPane label="总体费用"><all-pay></all-pay></TabPane>
        </Tabs>
      </div>
      <ul id="icon_menu">
        <router-link tag="li" to="/fenxi/licheng">
          <div class="icon icon1">
            <Icon type="md-timer" />
          </div>
          <p>里程分析</p>
        </router-link>
        <router-link tag="li" to="/fenxi/baojing">
          <div class="icon icon2">
            <Icon type="ios-warning" />
          </div>
          <p>报警分析</p>
        </router-link>
        <router-link tag="li" to="/fenxi/feiyong">
          <div class="icon icon3">
            <Icon type="logo-yen" />
          </div>
          <p>费用分析</p>
        </router-link>
      </ul>
      <remind></remind>
    </div>
  </div>
</template>
<script>
import remind from "./remind/remind.vue";
import carStatus from "./kanban/big/carStatus.vue";
import allPay from "./kanban/data/allPay.vue";
import licheng from "./kanban/data/licheng.vue";
var t;
export default {
  data() {
    return {
      item: {},
      menuList: [],
      openMyself: false,
      websock: null,
      locateData: [],
      bg: {
        0: "static/home0.jpg",
        1: "static/home1.jpg",
        2: "static/home2.jpg",
      },
      nowBg: 0,
    };
  },
  components: {
    remind,
    carStatus,
    allPay,
    licheng,
  },
  methods: {
    changeBg() {
      clearInterval(t);
      t = setInterval(() => {
        this.nowBg += 1;
        if (this.nowBg == 3) {
          this.nowBg = 0;
        }
      }, 3000);
    },
  },
  mounted() {
    this.changeBg();
  },
};
</script>
<style lang="">
#photo {
  width: 100%;
  overflow: hidden;
  text-align: center;
  background: #333;
  position: relative;
  /* background-image: linear-gradient(#13284e, #19263d); */
}
#photo .ivu-tabs-nav .ivu-tabs-tab {
  color: #fff;
}
#photo .ivu-tabs-ink-bar {
  background: #fff;
}
#photo .bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#icon_menu {
  display: flex;
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
}
#icon_menu li {
  width: 33.33%;
}
#icon_menu li .icon {
  color: #fff;
  width: 56px;
  height: 56px;
  background: #3c68ea;
  background-image: linear-gradient(to bottom right, #97c3f9, #3289f3);
  border-radius: 50%;
  margin: 30px auto 10px auto;
  font-size: 26px;
  line-height: 56px;
}
#icon_menu li .icon2 {
  background-image: linear-gradient(to bottom right, #f69b98, #ec3932);
}
#icon_menu li .icon3 {
  background-image: linear-gradient(to bottom right, #8ddea9, #1ebd56);
}
#icon_menu li .icon4 {
  background-image: linear-gradient(to bottom right, #fdc281, #fb8605);
}
#menu {
  width: 100%;
}
#menu li {
  width: 100%;
  height: 50px;
  text-align: left;
  padding: 0 10px;
  background: #fff;
  line-height: 40px;
}

#menu li i {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 10px;
  color: #7396f8;
}
#menu li:nth-child(2) i {
  color: #fa5a8f;
}
#menu li:nth-child(3) i {
  color: #16c56e;
}
#menu li:nth-child(4) i {
  color: #e6951d;
}
#menu li .right {
  text-align: right;
}
#menu li .right i {
  color: #ccc;
  margin: 0;
}
.myself {
  float: right;
  color: #999;
  line-height: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue